import { Spin } from 'antd';
import React, { PureComponent } from 'react';
import { sessionService } from 'redux-react-session';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { griffinInstance } from '../../common/helpers';

@connect(null, { push })
class Authenticated extends PureComponent {
    state = { isLoading: true };

    async componentDidMount() {
      try {
        const { roles } = await sessionService.loadSession();
        if (roles && roles.length > 0) {
          this.props.push("/")
        } else {
          this.handleCallback();
        }
      } catch (error) {
         console.error("Session loading failed:", error);
         this.handleCallback();
      }
    }

    handleCallback = async () => {
      try {
        const previousPath = sessionStorage.getItem('prevPath') || '/';

        const user = await griffinInstance({
          method: "GET",
          url: `/apis/whoami`,
        });

        const userData = user.data
        const roles = userData.response.groups
        const role = roles.length > 0 ? roles[0].replace("LDB-", "") : []

        await sessionService.saveSession({ roles: role });

        await sessionService.saveUser({
          user: {
            email: userData.response.username,
            name: userData.response.username,
            role: role
          }
        })

        this.props.push(previousPath);
      } catch (e) {
        console.error("error:", e);
      }
    };

    render() {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
          {this.state.isLoading ? <Spin size="large" /> : null}
        </div>
      );
    }
  }

  export default Authenticated;
